import settings from "../utils/settings";
import SFError from "../models/SfError";
const useImport = () => {
  const importFile = async ({ file, type = "products" }) => {
    const { token, realmId, branchId } = settings();

    try {
      let formData = new FormData();
      formData.append("image", file);
      formData.append("realm_id", realmId);
      if (branchId) formData.append("branch_id", branchId);
      formData.append("action", "import");
      let options = {
        method: "POST",
        body: formData,
        headers: {
          Authorization: `Bearer ${token}`,
        },
      };
      delete options.headers["Content-Type"];

      const result = await fetch(
        `${process.env.REACT_APP_API_ENDPOINT}/${type}/import`,
        options
      );
      const isOK = result.ok;
      const status = result.status;
      if (!isOK) {
        const jsonResult = await result.json();
        const error = new SFError({
          status: status,
          code: jsonResult.code,
          message: jsonResult.message,
        });

        return [null, error.json()];
      }
      const jsonResult = await result.json();
      return [jsonResult, null];
    } catch (error) {
      const sfError = new SFError({ message: String(error) });
      return [null, sfError];
    }
  };
  return { importFile };
};

export default useImport;
